import { booleanAttribute, Directive, input } from '@angular/core';

@Directive({
    selector: 'input[qpxEmail]',
    host: {
        '[attr.type]': '"email"',
        '[attr.inputmode]': '"email"',
        '[attr.autocomplete]': 'qpxIgnorePasswordManagers() ? "off" : "email"',
        '[attr.data-1p-ignore]': 'qpxIgnorePasswordManagers() ? "" : null',
        '[attr.data-lpignore]': 'qpxIgnorePasswordManagers() ? "true" : null',
        '[attr.data-bwignore]': 'qpxIgnorePasswordManagers() ? "true" : null',
        '[attr.data-form-type]': 'qpxIgnorePasswordManagers() ? "other" : null',
    },
})
export class QpxEmail {
    public readonly qpxIgnorePasswordManagers = input(false, {
        transform: booleanAttribute,
    });
}
